import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ContentHeader, ContentNav } from 'src/components'

class ProductsNavigation extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    static NAV_ITEMS = [
        {
            name: 'Overview',
            link: 'products-overview',
        },
        {
            name: 'Portfolios',
            link: 'products-portfolios',
        },
        {
            name: 'Solutions',
            link: 'products-solutions',
        },
        {
            name: 'SKUs',
            link: 'products-skus',
        },
    ]

    render() {
        const { title } = this.props

        return (
            <ContentHeader>
                <ContentNav
                    title={title}
                    contentNavItems={ProductsNavigation.NAV_ITEMS}
                >
                    {this.props.children}
                </ContentNav>
            </ContentHeader>
        )
    }
}

export default ProductsNavigation
